"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumProvider = void 0;
var contracts_1 = require("@ethersproject/contracts");
var providers_1 = require("@ethersproject/providers");
var detect_provider_1 = __importDefault(require("@metamask/detect-provider"));
var pkce_challenge_1 = __importDefault(require("pkce-challenge"));
var reconnecting_websocket_1 = __importDefault(require("reconnecting-websocket"));
var frontend_provider_types_1 = require("@manifoldxyz/frontend-provider-types");
var asyncFnInFlightMemoize_1 = require("./lib/asyncFnInFlightMemoize");
var functions_1 = require("./lib/functions");
var servers_1 = require("./lib/servers");
var storage_1 = require("./lib/storage");
var EthereumProviderMultipleChains = /** @class */ (function (_super) {
    __extends(EthereumProviderMultipleChains, _super);
    function EthereumProviderMultipleChains(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = frontend_provider_types_1.EthereumProviderErrorName.EthereumProviderMultipleChains;
        return _this;
    }
    return EthereumProviderMultipleChains;
}(Error));
var WindowEthereumConnectionError = /** @class */ (function (_super) {
    __extends(WindowEthereumConnectionError, _super);
    function WindowEthereumConnectionError(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = frontend_provider_types_1.EthereumProviderErrorName.WindowEthereumConnectionError;
        return _this;
    }
    return WindowEthereumConnectionError;
}(Error));
var _EthereumProvider = /** @class */ (function () {
    function _EthereumProvider() {
    }
    _EthereumProvider.initialize = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var fallbackHost, signingProvider, browserProviderOverride, _a, browserProviderTimeout, _b, browserProviderIgnoreDisconnect, network, fallbackHostObject, fallbackHostString;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        fallbackHost = options.fallbackHost, signingProvider = options.signingProvider, browserProviderOverride = options.browserProviderOverride, _a = options.browserProviderTimeout, browserProviderTimeout = _a === void 0 ? 1000 : _a, _b = options.browserProviderIgnoreDisconnect, browserProviderIgnoreDisconnect = _b === void 0 ? false : _b;
                        network = options.network;
                        fallbackHostObject = fallbackHost && typeof fallbackHost !== 'string'
                            ? fallbackHost
                            : undefined;
                        fallbackHostString = fallbackHost && typeof fallbackHost === 'string' ? fallbackHost : undefined;
                        if (network && fallbackHostObject) {
                            throw new Error('network cannot be provided if a map is passed in for fallbackHost');
                        }
                        // Configure network
                        if (network) {
                            // Even though we type network, someone might accidentally pass in a string
                            network = parseInt(network.toString());
                            if (isNaN(network))
                                throw new Error('Invalid network provided');
                        }
                        else if (fallbackHostObject && Object.keys(fallbackHostObject).length === 1) {
                            network = parseInt(Object.keys(fallbackHostObject)[0]);
                            fallbackHostString = fallbackHostObject[network];
                            fallbackHostObject = undefined;
                        }
                        // If network was already set, all networks must be the same
                        if (this._network && this._network != network)
                            throw new EthereumProviderMultipleChains('Only one chain can be used at a time.');
                        this._network = network;
                        if (!signingProvider) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setSigningProvider(signingProvider)];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        if (!(!fallbackHost && !signingProvider)) return [3 /*break*/, 4];
                        // No fallback provider so we want to wait for ethereum provider
                        // The reason we don't require to _initializeBrowserProvider when a fallback provider is given is because we want fast loading
                        return [4 /*yield*/, this._initializeBrowserProvider(browserProviderOverride, browserProviderTimeout, browserProviderIgnoreDisconnect)];
                    case 3:
                        // No fallback provider so we want to wait for ethereum provider
                        // The reason we don't require to _initializeBrowserProvider when a fallback provider is given is because we want fast loading
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        if (this.initialized) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._initializeFallbackAndBrowserProvider(network, fallbackHostString, fallbackHostObject, browserProviderOverride, browserProviderTimeout, browserProviderIgnoreDisconnect)];
                    case 5:
                        _c.sent();
                        this.initialized = true;
                        window.dispatchEvent(new Event(frontend_provider_types_1.MANIFOLD_ETHEREUM_INITIALIZED));
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get a JsonRpcProvider based on the host and network
     */
    _EthereumProvider._getProvider = function (host, network) {
        if (host.startsWith('ws')) {
            if (network) {
                return new providers_1.WebSocketProvider(new reconnecting_websocket_1.default(host), network);
            }
            else {
                return new providers_1.WebSocketProvider(new reconnecting_websocket_1.default(host));
            }
        }
        else {
            if (network) {
                return new providers_1.JsonRpcProvider(host, network);
            }
            else {
                return new providers_1.JsonRpcProvider(host);
            }
        }
    };
    _EthereumProvider._initializeFallbackAndBrowserProvider = function (network, fallbackhostString, fallbackhostObject, browserProviderOverride, browserProviderTimeout, browserProviderIgnoreDisconnect) {
        if (browserProviderTimeout === void 0) { browserProviderTimeout = 1000; }
        if (browserProviderIgnoreDisconnect === void 0) { browserProviderIgnoreDisconnect = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(fallbackhostString !== undefined)) return [3 /*break*/, 6];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        if (!network) return [3 /*break*/, 2];
                        this._fallbackProvider = this._getProvider(fallbackhostString, parseInt(network.toString()));
                        this._fallbackProviderChainId = parseInt(network.toString());
                        return [3 /*break*/, 4];
                    case 2:
                        this._fallbackProvider = this._getProvider(fallbackhostString);
                        _a = this;
                        return [4 /*yield*/, this._fallbackProvider.getNetwork()];
                    case 3:
                        _a._fallbackProviderChainId = (_c.sent()).chainId;
                        _c.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        _b = _c.sent();
                        console.warn('Fallback Provider has invalid URL');
                        return [3 /*break*/, 6];
                    case 6:
                        if (fallbackhostObject) {
                            this._fallbackHosts = fallbackhostObject;
                        }
                        // Setup browser provider
                        return [4 /*yield*/, this._initializeBrowserProvider(browserProviderOverride, browserProviderTimeout, browserProviderIgnoreDisconnect)];
                    case 7:
                        // Setup browser provider
                        _c.sent();
                        // Set provider
                        this._setProvider();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initialize the browser provider
     */
    _EthereumProvider._initializeBrowserProvider = function (browserProviderOverride, browserProviderTimeout, browserProviderIgnoreDisconnect) {
        if (browserProviderTimeout === void 0) { browserProviderTimeout = 1000; }
        if (browserProviderIgnoreDisconnect === void 0) { browserProviderIgnoreDisconnect = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this._browserProviderInitialized) return [3 /*break*/, 6];
                        // Only configure once
                        this._browserProviderInitialized = true;
                        if (!browserProviderOverride) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._setupBrowserProvider(browserProviderOverride, browserProviderIgnoreDisconnect)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        if (!!window.ethereum) return [3 /*break*/, 4];
                        // No browser provider yet, configure once complete
                        return [4 /*yield*/, (0, detect_provider_1.default)({
                                mustBeMetaMask: false,
                                silent: true,
                                timeout: browserProviderTimeout,
                            })];
                    case 3:
                        // No browser provider yet, configure once complete
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!window.ethereum) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._setupBrowserProvider(window.ethereum, browserProviderIgnoreDisconnect)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Setup a browser provider
     */
    _EthereumProvider._setupBrowserProvider = function (provider, browserProviderIgnoreDisconnect) {
        if (browserProviderIgnoreDisconnect === void 0) { browserProviderIgnoreDisconnect = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Have browser provider, try to configure
                        // Add listeners
                        provider.on('accountsChanged', function () {
                            _this._handleEthereumAccountChange();
                        });
                        provider.on('chainChanged', function (chainInfo) {
                            _this._handleEthereumChainChange(chainInfo);
                        });
                        if (!browserProviderIgnoreDisconnect) {
                            provider.on('disconnect', function () {
                                _this._browserSelectedAddress = undefined;
                                _this._browserSelectedENSName = undefined;
                                window.dispatchEvent(new Event(frontend_provider_types_1.ADDRESS_CHANGED));
                            });
                        }
                        if (!(provider &&
                            this._isBrowserProviderConnected(provider) &&
                            (!this._browserProvider || this._browserProvider.provider != provider))) return [3 /*break*/, 4];
                        // Use the browser provider if it is connected
                        this._browserProvider = new providers_1.Web3Provider(provider, 'any');
                        if (!provider.chainId) return [3 /*break*/, 1];
                        this._browserProviderChainId = parseInt(provider.chainId);
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, this._browserProvider.getNetwork()];
                    case 2:
                        _a._browserProviderChainId = (_b.sent()).chainId;
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        if (provider && !this._isBrowserProviderConnected(provider)) {
                            // Browser provider not connected, listen for connection
                            provider.on('connect', function (connectInfo) {
                                _this._handleEthereumConnect(connectInfo);
                            });
                        }
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Helper to check if browser provider is connected
     */
    _EthereumProvider._isBrowserProviderConnected = function (provider) {
        if (provider) {
            // Basic metamask handling
            if (provider.connected === true || (provider.isConnected && provider.isConnected()))
                return true;
            // Coinbase wrapped metamask handling
            if (provider.providers) {
                if (provider.providers.length) {
                    for (var _i = 0, _a = provider.providers; _i < _a.length; _i++) {
                        var providerInstance = _a[_i];
                        if (providerInstance.connected === true ||
                            (providerInstance.isConnected && providerInstance.isConnected()))
                            return true;
                    }
                }
            }
            // Other injected providers
            if (provider.isInjected)
                return true;
            // Unknown window.ethereum handling (assume connected)
            if (window.ethereum.connected === undefined &&
                window.ethereum.isConnected === undefined &&
                window.ethereum.providers === undefined)
                return true;
        }
        return false;
    };
    // Set provider based on configured chain
    _EthereumProvider._setProvider = function () {
        var providerChanged = false;
        if (this._browserProvider &&
            ((!this._network && !this._signingProviderChainId) ||
                (this._network && this._browserProviderChainId == this._network) ||
                (this._signingProviderChainId &&
                    this._browserProviderChainId == this._signingProviderChainId))) {
            // We can use the browserProvider because it is on the correct network
            // It is the correct network IF
            // 1. There is no network specified and no signing provider chain was set
            // 2. The browser provider chain matches the network
            // 3. There is a signing provider and the signing provider's chain matches the browser chain
            if (this._provider != this._browserProvider ||
                this._providerChainId != this._browserProviderChainId) {
                this._provider = this._browserProvider;
                this._providerChainId = this._browserProviderChainId;
                providerChanged = true;
            }
        }
        else {
            // We cannot use the browser provider to sign as we are not on the right network
            if (this._signingProvider == this._browserProvider) {
                // If signing provider was the browser provider, set it to undefined as it is no longer connected
                this._signingProvider = undefined;
            }
            if (this._fallbackProvider || this._signingProvider) {
                // Use the fallback or signing provider if available
                if (this._fallbackProvider) {
                    this._provider = this._fallbackProvider;
                    this._providerChainId = this._fallbackProviderChainId;
                }
                else if (this._signingProvider) {
                    this._provider = this._signingProvider;
                    this._providerChainId = this._signingProviderChainId;
                }
                providerChanged = true;
            }
            else {
                // No provider available
                if (this._provider) {
                    providerChanged = true;
                    this._provider = undefined;
                    this._providerChainId = undefined;
                }
                this._provider = undefined;
            }
        }
        // Dispatch event if provider changed
        if (providerChanged) {
            window.dispatchEvent(new Event(frontend_provider_types_1.PROVIDER_CHANGED));
        }
    };
    /**
     * Handle ethereum connection
     */
    _EthereumProvider._handleEthereumConnect = function (chainInfo) {
        // Ethereum connection
        if (!this._browserProvider) {
            this._browserProvider = new providers_1.Web3Provider(window.ethereum, 'any');
        }
        this._handleEthereumChainChange(chainInfo);
    };
    /**
     * Handle ethereum chain changes
     */
    _EthereumProvider._handleEthereumChainChange = function (chainInfo) {
        var _a;
        // We do chainInfo.chainId ?? chainInfo because some providers (i.e. MetaMask)
        // incorrectly emit chainChanged as just the chainId in hex, rather than following EIP-1193
        var chainId = (_a = chainInfo.chainId) !== null && _a !== void 0 ? _a : chainInfo;
        // Convert chainId to int
        if (!Number.isInteger(chainId)) {
            chainId = Number(chainId);
        }
        // Chain change, you want to set up to use the right provider
        this._browserProviderChainId = chainId;
        this._setProvider();
        window.dispatchEvent(new CustomEvent(frontend_provider_types_1.CHAIN_CHANGED));
    };
    /**
     * Handle Ethereum account changes
     */
    _EthereumProvider._handleEthereumAccountChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newSelectedAddress, newSelectedENSName, accounts, e_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSelectedAddress = undefined;
                        newSelectedENSName = undefined;
                        if (!(this._browserProvider && !this._userDisconnected)) return [3 /*break*/, 8];
                        accounts = void 0;
                        if (!this._browserProvider.provider.selectedAddress) return [3 /*break*/, 1];
                        // Already connected
                        accounts = [this._browserProvider.provider.selectedAddress];
                        return [3 /*break*/, 7];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._browserProvider.listAccounts()];
                    case 2:
                        accounts = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1.code === 4900 || e_1.code === 'INVALID_ARGUMENT') {
                            // Do nothing, we are not yet connected
                        }
                        else {
                            throw e_1;
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(!accounts ||
                            (!accounts.length &&
                                (this._browserProvider.provider.isMetaMask ||
                                    this._browserProvider.provider.isCoinbaseWallet ||
                                    this._browserProvider.provider.isLedgerConnect ||
                                    this._browserProvider.provider.isBitski ||
                                    this._browserProvider.provider.isDawn ||
                                    this._browserProvider.provider.isManifoldAppBridge)))) return [3 /*break*/, 7];
                        // If this is MetaMask we need to enable it by making a request
                        // @ts-ignore
                        return [4 /*yield*/, this._browserProvider.provider.request({
                                method: 'eth_requestAccounts',
                            })];
                    case 5:
                        // If this is MetaMask we need to enable it by making a request
                        // @ts-ignore
                        _a.sent();
                        return [4 /*yield*/, this._browserProvider.listAccounts()];
                    case 6:
                        accounts = _a.sent();
                        _a.label = 7;
                    case 7:
                        if (accounts.length) {
                            newSelectedAddress = accounts[0].toLowerCase();
                        }
                        _a.label = 8;
                    case 8:
                        if (!(newSelectedAddress != this._browserSelectedAddress)) return [3 /*break*/, 14];
                        this._browserSelectedAddress = newSelectedAddress;
                        this._browserSelectedENSName = undefined;
                        if (!(newSelectedAddress && this._provider)) return [3 /*break*/, 13];
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 12, , 13]);
                        if (!(!this._provider.isWalletConnect || this._fallbackProvider)) return [3 /*break*/, 11];
                        return [4 /*yield*/, this._provider.lookupAddress(newSelectedAddress)];
                    case 10:
                        newSelectedENSName = _a.sent();
                        _a.label = 11;
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        error_1 = _a.sent();
                        return [3 /*break*/, 13];
                    case 13:
                        if (newSelectedENSName) {
                            this._browserSelectedENSName = newSelectedENSName;
                        }
                        window.dispatchEvent(new Event(frontend_provider_types_1.ADDRESS_CHANGED));
                        _a.label = 14;
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    _EthereumProvider.hasBrowserProvider = function () {
        if (this._browserProvider)
            return true;
        return false;
    };
    _EthereumProvider.browserProvider = function () {
        return this._browserProvider;
    };
    _EthereumProvider.browserChainId = function () {
        if (this._browserProvider) {
            return this._browserProviderChainId;
        }
        return undefined;
    };
    _EthereumProvider.setSigningProvider = function (provider) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var signingProviderChainId, chainChanged, addressChanged, newSigningProviderAddress, newSelectedENSName, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, provider.getNetwork()];
                    case 1:
                        signingProviderChainId = (_b.sent()).chainId;
                        if (this._network && signingProviderChainId != this._network)
                            throw new Error('Signing provider mismatched network');
                        this._signingProvider = provider;
                        chainChanged = false;
                        addressChanged = false;
                        if (!this._network) {
                            // Multi network component (i.e. we can switch networks)
                            if (signingProviderChainId != this._fallbackProviderChainId) {
                                // Mismatched signing/fallback provider chains, try and use a fallback provider with
                                // a matching chain or set undefined
                                if (this._fallbackProviders && this._fallbackProviders[signingProviderChainId]) {
                                    this._fallbackProvider = this._fallbackProviders[signingProviderChainId];
                                    this._fallbackProviderChainId = signingProviderChainId;
                                }
                                else if (this._fallbackHosts && this._fallbackHosts[signingProviderChainId]) {
                                    this._fallbackProvider = this._getProvider(this._fallbackHosts[signingProviderChainId], signingProviderChainId);
                                    this._fallbackProviderChainId = signingProviderChainId;
                                    if (!this._fallbackProviders)
                                        this._fallbackProviders = {};
                                    // Cache the provider
                                    this._fallbackProviders[signingProviderChainId] = this._fallbackProvider;
                                }
                                else {
                                    this._fallbackProvider = undefined;
                                    this._fallbackProviderChainId = undefined;
                                }
                            }
                        }
                        if (this._signingProviderChainId !== signingProviderChainId) {
                            this._signingProviderChainId = signingProviderChainId;
                            chainChanged = true;
                        }
                        return [4 /*yield*/, provider.getSigner().getAddress()];
                    case 2:
                        newSigningProviderAddress = (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                        if (!(newSigningProviderAddress != this._signingProviderAddress)) return [3 /*break*/, 8];
                        this._signingProviderENSName = undefined;
                        newSelectedENSName = undefined;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 6, , 7]);
                        if (!(!provider.isWalletConnect || this._fallbackProvider)) return [3 /*break*/, 5];
                        return [4 /*yield*/, provider.lookupAddress(newSigningProviderAddress)];
                    case 4:
                        newSelectedENSName = _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_2 = _b.sent();
                        return [3 /*break*/, 7];
                    case 7:
                        this._signingProviderAddress = newSigningProviderAddress;
                        if (newSelectedENSName)
                            this._signingProviderENSName = newSelectedENSName;
                        window.dispatchEvent(new Event(frontend_provider_types_1.ADDRESS_CHANGED));
                        addressChanged = true;
                        _b.label = 8;
                    case 8:
                        if (chainChanged || addressChanged) {
                            this._setProvider();
                            if (chainChanged) {
                                // dispath this only after _setProvider so local members are set properly before dispatching event
                                window.dispatchEvent(new CustomEvent(frontend_provider_types_1.CHAIN_CHANGED));
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    _EthereumProvider.connect = function (browserProviderOverride) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(browserProviderOverride && browserProviderOverride !== ((_a = this._browserProvider) === null || _a === void 0 ? void 0 : _a.provider))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._setupBrowserProvider(browserProviderOverride)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        // Cannot connect if there is no active browser connection
                        if (!this._browserProvider ||
                            !this._isBrowserProviderConnected(this._browserProvider.provider)) {
                            throw new WindowEthereumConnectionError();
                        }
                        if (!(!this._browserSelectedAddress && !this._connecting)) return [3 /*break*/, 6];
                        this._connecting = true;
                        this._userDisconnected = false;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._handleEthereumAccountChange()];
                    case 4:
                        _b.sent();
                        this._connecting = false; // we have fully connected
                        return [3 /*break*/, 6];
                    case 5:
                        error_3 = _b.sent();
                        this._connecting = false;
                        throw error_3; // allow client to handle the error (usually rejection)
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    _EthereumProvider.disconnect = function (strictAuth) {
        if (strictAuth === void 0) { strictAuth = true; }
        if (this._browserSelectedAddress) {
            (0, storage_1.deleteOAuth)(this._browserSelectedAddress, strictAuth);
        }
        if (this._signingProviderAddress) {
            (0, storage_1.deleteOAuth)(this._signingProviderAddress, strictAuth);
        }
        this._browserSelectedAddress = undefined;
        this._browserSelectedENSName = undefined;
        this._signingProviderAddress = undefined;
        this._signingProviderENSName = undefined;
        this._signingProvider = undefined;
        this._signingProviderChainId = undefined;
        this._userDisconnected = true;
        window.dispatchEvent(new Event(frontend_provider_types_1.ADDRESS_CHANGED));
    };
    _EthereumProvider.provider = function (withSigner) {
        if (withSigner === void 0) { withSigner = false; }
        if (withSigner) {
            // Use signging provider if configured
            if (this._signingProvider)
                return this._signingProvider;
            // Use browser provider if connected
            if (this._browserSelectedAddress && this.chainIsCorrect())
                return this._browserProvider;
            // No signing provider available
            return undefined;
        }
        return this._provider;
    };
    _EthereumProvider.contractInstance = function (address, abi, withSigner, unchecked) {
        if (withSigner === void 0) { withSigner = false; }
        if (unchecked === void 0) { unchecked = false; }
        var provider = this.provider(withSigner);
        if (provider === undefined)
            return undefined;
        var contract = new contracts_1.Contract(address, abi, provider);
        // Attach the signer if the provider is the browser provider
        if (withSigner) {
            if (unchecked) {
                contract = contract.connect(provider.getUncheckedSigner());
            }
            else {
                contract = contract.connect(provider.getSigner());
            }
        }
        return contract;
    };
    _EthereumProvider.contractFactoryInstance = function (abi, bytecode, unchecked) {
        if (unchecked === void 0) { unchecked = false; }
        var provider = this.provider(true);
        if (provider === undefined)
            return undefined;
        if (unchecked) {
            return new contracts_1.ContractFactory(abi, bytecode, provider.getUncheckedSigner());
        }
        else {
            return new contracts_1.ContractFactory(abi, bytecode, provider.getSigner());
        }
    };
    _EthereumProvider.selectedAddress = function () {
        return this._signingProviderAddress || this._browserSelectedAddress;
    };
    _EthereumProvider.selectedENSName = function () {
        return this._signingProviderENSName || this._browserSelectedENSName;
    };
    _EthereumProvider.network = function () {
        return this._network;
    };
    _EthereumProvider.chainId = function () {
        return this._providerChainId;
    };
    _EthereumProvider.switchToChain = function (chainId) {
        return __awaiter(this, void 0, void 0, function () {
            var provider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        provider = this.provider(true) || this._browserProvider;
                        if (!provider) return [3 /*break*/, 2];
                        return [4 /*yield*/, provider.send('wallet_switchEthereumChain', [{ chainId: "0x".concat(chainId.toString(16)) }])];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    _EthereumProvider.switchToCorrectChain = function () {
        return __awaiter(this, void 0, void 0, function () {
            var correctChainId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        correctChainId = this._network;
                        if (!(correctChainId !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.switchToChain(correctChainId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns true if:
     *    You specified a signing provider
     *    There is no detected browser chain
     *    There is no network specified
     *    You are connected and your browser provider is using the same chain as the network
     *
     * Primarily use this after you connect.
     * Use this to check a user is on the right chain for WRITE functions.
     * Use this to show a warning if they're on the wrong chain AND connected
     *
     * @returns chainIsCorrect: bool
     */
    _EthereumProvider.chainIsCorrect = function () {
        return (this._signingProvider !== undefined ||
            this._browserProviderChainId === undefined ||
            this._network === undefined ||
            this._browserProviderChainId == this._network);
    };
    _EthereumProvider.getOAuth = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var grantType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        grantType = options.grantType;
                        if (options.message && grantType !== 'signature') {
                            throw new Error('Custom `message` can only be used with the `signature` grant type');
                        }
                        if (!(grantType === 'token')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._getOAuthGrantTypeToken(options)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(grantType === 'signature')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._getOAuthGrantTypeSignature(options)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4: throw new Error("Invalid grant type. Received \"".concat(grantType, "\""));
                }
            });
        });
    };
    /**
     * Gets a token for the Implicit Grant flow for OAuth. Similar
     * to the other JWT method, this immediately gets a token
     * with which you can query our APIs.
     */
    _EthereumProvider._getOAuthGrantTypeToken = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var appName, clientId, _a, strictAuth, _b, delayAuth, account, oauth, url, challenge, provider, signature, chainId, res, resJson;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        appName = options.appName, clientId = options.clientId, _a = options.strictAuth, strictAuth = _a === void 0 ? true : _a, _b = options.delayAuth, delayAuth = _b === void 0 ? false : _b;
                        account = this.selectedAddress();
                        if (!account)
                            throw new Error('Must connect before getting OAuth token');
                        return [4 /*yield*/, (0, storage_1.getOAuth)(account, strictAuth)];
                    case 1:
                        oauth = _c.sent();
                        if (!(!oauth && !delayAuth)) return [3 /*break*/, 6];
                        url = "".concat(servers_1.OAuthServer, "/token");
                        challenge = "Please sign this to allow ".concat(appName, " access to view your NFTs.");
                        provider = this.provider(true) || this._browserProvider;
                        if (!provider)
                            throw new Error('Not connected');
                        return [4 /*yield*/, provider.getSigner().signMessage(challenge)];
                    case 2:
                        signature = _c.sent();
                        return [4 /*yield*/, provider.getNetwork()];
                    case 3:
                        chainId = (_c.sent()).chainId;
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Accept: 'application/json',
                                },
                                body: JSON.stringify({
                                    signature: signature,
                                    appName: appName,
                                    clientId: clientId,
                                    grantType: 'token',
                                    chainId: chainId,
                                }),
                            })];
                    case 4:
                        res = _c.sent();
                        if (res.status != 200)
                            throw new Error('Could not verify');
                        return [4 /*yield*/, res.json()];
                    case 5:
                        resJson = _c.sent();
                        if (!resJson.access_token)
                            throw new Error('Could not verify');
                        (0, storage_1.setOAuth)(account, strictAuth, resJson.access_token);
                        oauth = resJson.access_token;
                        _c.label = 6;
                    case 6: return [2 /*return*/, oauth];
                }
            });
        });
    };
    /**
     * The `signature` grant type is a custom oauth grant type to authenticate via a public key with digital signatures.
     *
     * Read more:
     * https://github.com/manifoldxyz/oauth-server/blob/cd574af2d6710eb252ab7bc68310551a400657e2/src/views/controllers/grant_types/signature.ts
     */
    _EthereumProvider._getOAuthGrantTypeSignature = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var account, appName, clientId, _a, strictAuth, _b, delayAuth, userCallback, oauth, provider, challenge_1, authResponse, code_1, message_1, signature_1, chainId_1, accessToken, data, tokenResponse, data;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        account = this.selectedAddress();
                        if (!account)
                            throw new Error('Must connect before getting OAuth token');
                        appName = options.appName, clientId = options.clientId, _a = options.strictAuth, strictAuth = _a === void 0 ? true : _a, _b = options.delayAuth, delayAuth = _b === void 0 ? false : _b, userCallback = options.userCallback;
                        return [4 /*yield*/, (0, storage_1.getOAuth)(account, strictAuth)];
                    case 1:
                        oauth = _c.sent();
                        if (!(!oauth && !delayAuth)) return [3 /*break*/, 14];
                        provider = this.provider(true) || this._browserProvider;
                        if (!provider)
                            throw new Error('Not connected');
                        challenge_1 = (0, pkce_challenge_1.default)();
                        return [4 /*yield*/, fetch("".concat(servers_1.OAuthServer, "/auth"), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Accept: 'application/json',
                                },
                                body: JSON.stringify({
                                    clientId: clientId,
                                    grantType: 'signature',
                                    address: account,
                                    codeChallenge: challenge_1.code_challenge,
                                }),
                            })];
                    case 2:
                        authResponse = _c.sent();
                        return [4 /*yield*/, authResponse.json()];
                    case 3:
                        code_1 = (_c.sent()).oauth_code;
                        message_1 = options.message || "Please sign this to allow ".concat(appName, " access to view your NFTs.");
                        message_1 += "\n\nChallenge: ".concat(code_1);
                        if (!userCallback) return [3 /*break*/, 5];
                        return [4 /*yield*/, userCallback(message_1)];
                    case 4:
                        signature_1 = _c.sent();
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, provider.getSigner().signMessage(message_1)];
                    case 6:
                        signature_1 = _c.sent();
                        _c.label = 7;
                    case 7: return [4 /*yield*/, provider.getNetwork()];
                    case 8:
                        chainId_1 = (_c.sent()).chainId;
                        accessToken = void 0;
                        if (!(signature_1 === '0x')) return [3 /*break*/, 10];
                        return [4 /*yield*/, (0, functions_1.poll)({
                                interval: 5000,
                                maxAttempts: 70,
                                fetchApi: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        return [2 /*return*/, fetch("".concat(servers_1.OAuthServer, "/token"), {
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    Accept: 'application/json',
                                                },
                                                body: JSON.stringify({
                                                    clientId: clientId,
                                                    signature: signature_1,
                                                    code: code_1,
                                                    appName: appName,
                                                    message: message_1,
                                                    codeVerifier: challenge_1.code_verifier,
                                                    grantType: 'signature',
                                                    chainId: chainId_1,
                                                }),
                                            })];
                                    });
                                }); },
                                onError: function (err) { return __awaiter(_this, void 0, void 0, function () {
                                    var message;
                                    var _a;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0: return [4 /*yield*/, (err === null || err === void 0 ? void 0 : err.json())];
                                            case 1:
                                                message = _b.sent();
                                                if ((_a = message === null || message === void 0 ? void 0 : message.error) === null || _a === void 0 ? void 0 : _a.includes('Signature verification unsuccessful')) {
                                                    // do nothing and let poll retry
                                                }
                                                else {
                                                    throw err;
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                }); },
                            })];
                    case 9:
                        data = _c.sent();
                        accessToken = data.access_token;
                        return [3 /*break*/, 13];
                    case 10: return [4 /*yield*/, fetch("".concat(servers_1.OAuthServer, "/token"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                            },
                            body: JSON.stringify({
                                clientId: clientId,
                                signature: signature_1,
                                code: code_1,
                                appName: appName,
                                message: message_1,
                                codeVerifier: challenge_1.code_verifier,
                                grantType: 'signature',
                                chainId: chainId_1,
                            }),
                        })];
                    case 11:
                        tokenResponse = _c.sent();
                        if (tokenResponse.status !== 200) {
                            throw new Error('Could not verify');
                        }
                        return [4 /*yield*/, tokenResponse.json()];
                    case 12:
                        data = (_c.sent());
                        accessToken = data.access_token;
                        _c.label = 13;
                    case 13:
                        if (!accessToken)
                            throw new Error('Could not verify');
                        (0, storage_1.setOAuth)(account, strictAuth, accessToken);
                        oauth = accessToken;
                        _c.label = 14;
                    case 14: return [2 /*return*/, oauth];
                }
            });
        });
    };
    _EthereumProvider._provider = undefined;
    _EthereumProvider._providerChainId = undefined;
    _EthereumProvider._browserProviderInitialized = false;
    _EthereumProvider._browserProvider = undefined;
    _EthereumProvider._browserProviderChainId = undefined;
    _EthereumProvider._browserSelectedAddress = undefined;
    _EthereumProvider._browserSelectedENSName = undefined;
    _EthereumProvider._signingProvider = undefined;
    _EthereumProvider._signingProviderChainId = undefined;
    _EthereumProvider._signingProviderAddress = undefined;
    _EthereumProvider._signingProviderENSName = undefined;
    _EthereumProvider._fallbackProvider = undefined;
    _EthereumProvider._fallbackProviderChainId = undefined;
    _EthereumProvider._fallbackHosts = undefined;
    _EthereumProvider._fallbackProviders = undefined;
    _EthereumProvider._connecting = false;
    // This variable is used to track user website disconnections and prevent auto reconnection when a user disconnects via the interface
    // then triggers a metamask disconnection (which would subsequently trigger a accountsChanged event)
    _EthereumProvider._userDisconnected = false;
    // Configuration
    _EthereumProvider.initialized = false;
    __decorate([
        asyncFnInFlightMemoize_1.asyncFnInFlightMemoize // Dedupe identical invocations of this fn if promise is in flight
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, String, Object, Object, Object, Object]),
        __metadata("design:returntype", Promise)
    ], _EthereumProvider, "_initializeFallbackAndBrowserProvider", null);
    __decorate([
        asyncFnInFlightMemoize_1.asyncFnInFlightMemoize,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, Object]),
        __metadata("design:returntype", Promise)
    ], _EthereumProvider, "_initializeBrowserProvider", null);
    __decorate([
        asyncFnInFlightMemoize_1.asyncFnInFlightMemoize // Dedupe identical invocations of this fn if promise is in flight
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], _EthereumProvider, "getOAuth", null);
    return _EthereumProvider;
}());
// Singleton instance
var EthereumProvider = _EthereumProviderSingleton();
exports.EthereumProvider = EthereumProvider;
// Instantiate EthereumProvider singleton
function _EthereumProviderSingleton() {
    if (!window.ManifoldEthereumProvider) {
        window.ManifoldEthereumProvider = _EthereumProvider;
        window.dispatchEvent(new CustomEvent(frontend_provider_types_1.MANIFOLD_ETHEREUM_EXISTS));
    }
    return window.ManifoldEthereumProvider;
}
